/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AmountValidationError = {
  currency?: string | undefined;
  value?: string | undefined;
};

/** @internal */
export const AmountValidationError$inboundSchema: z.ZodType<
  AmountValidationError,
  z.ZodTypeDef,
  unknown
> = z.object({
  currency: z.string().optional(),
  value: z.string().optional(),
});
/** @internal */
export type AmountValidationError$Outbound = {
  currency?: string | undefined;
  value?: string | undefined;
};

/** @internal */
export const AmountValidationError$outboundSchema: z.ZodType<
  AmountValidationError$Outbound,
  z.ZodTypeDef,
  AmountValidationError
> = z.object({
  currency: z.string().optional(),
  value: z.string().optional(),
});

export function amountValidationErrorToJSON(
  amountValidationError: AmountValidationError,
): string {
  return JSON.stringify(
    AmountValidationError$outboundSchema.parse(amountValidationError),
  );
}
export function amountValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<AmountValidationError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AmountValidationError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AmountValidationError' from JSON`,
  );
}
